import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { AdminAuthProvider, useAdminAuth } from '@/lib/admin-auth-context'
import { AdminSidebar } from '@/components/admin/admin-sidebar'
import { AdminHeader } from '@/components/admin/admin-header'
import { cn } from '@/lib/utils'

function AdminLayoutContent() {
    const { isAuthenticated, isLoading } = useAdminAuth()
    const { pathname } = useLocation()

    // Show loading state
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-gray-950">
                <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                    <p className="text-muted-foreground">Yuklanmoqda...</p>
                </div>
            </div>
        )
    }

    // Check if on login page
    const isLoginPage = pathname === '/admin/login'

    // Redirect to login if not authenticated and not on login page
    if (!isAuthenticated && !isLoginPage) {
        return <Navigate to="/admin/login" replace />
    }

    // Redirect to dashboard if authenticated and on login page
    if (isAuthenticated && isLoginPage) {
        return <Navigate to="/admin" replace />
    }

    // Render login page without sidebar
    if (isLoginPage) {
        return <Outlet />
    }

    // Render authenticated admin layout
    return (
        <div className="min-h-screen bg-slate-50 dark:bg-gray-950">
            <AdminSidebar />
            <div className={cn(
                "transition-all duration-300",
                "lg:pl-[280px]"
            )}>
                <AdminHeader />
                <main className="p-4 lg:p-8">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export function AdminLayout() {
    return (
        <AdminAuthProvider>
            <AdminLayoutContent />
        </AdminAuthProvider>
    )
}
